
/* =========================================
   SELEN - WOKIEE 3.4
   SHOPIFY INBOX - V9

   ASCUNDERE PE MOBIL:
   1. FILTRE
   2. COS LATERAL
   3. MENIU MOBIL
   4. BARA DE CAUTARE
========================================= */

(function () {
  "use strict";

  const BREAKPOINT = 1024;
  const ACTIVE_CLASS = "selen-mobile-overlay-open";
  const STYLE_ID = "selen-inbox-overlay-v9";

  const mobileQuery = window.matchMedia(
    "(max-width: " + BREAKPOINT + "px)"
  );

  let filtersOpen = false;
  let cartOpen = false;
  let menuOpen = false;
  let searchOpen = false;

  let closingFilters = false;
  let closingCart = false;
  let closingSearch = false;

  let searchOpenedAt = 0;
  let scheduled = false;

  /* =====================================
     CSS SHOPIFY INBOX
  ===================================== */

  function installStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    const style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      @media screen and (max-width: 1024px) {
        html.${ACTIVE_CLASS} shopify-chat,
        html.${ACTIVE_CLASS} #shopify-chat,
        html.${ACTIVE_CLASS} #ShopifyChat,
        html.${ACTIVE_CLASS} inbox-online-store-chat {
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  /* =====================================
     ELEMENTE WOKIEE
  ===================================== */

  function getFilterModal() {
    const form = document.getElementById(
      "FacetFiltersFormMobile"
    );

    return form
      ? form.closest(".popup-modal")
      : null;
  }

  function getFilterDialog() {
    const form = document.getElementById(
      "FacetFiltersFormMobile"
    );

    return form
      ? form.closest(".popup-modal__content_data")
      : null;
  }

  function getCartDrawer() {
    return document.getElementById("CartDrawer");
  }

  function getMenuDetails() {
    return document.querySelector(
      "menu-drawer > details.disclosure-has-popup"
    ) || document.querySelector(
      "menu-drawer > details"
    );
  }

  function getSearchModal() {
    return document.getElementById(
      "header-modal-search"
    );
  }

  /* =====================================
     VERIFICARE VIZIBILITATE
  ===================================== */

  function isVisible(element) {
    if (!element || !element.isConnected) {
      return false;
    }

    let current = element;

    while (
      current &&
      current.nodeType === 1
    ) {
      const style = window.getComputedStyle(
        current
      );

      if (
        current.hidden ||
        style.display === "none" ||
        style.visibility === "hidden" ||
        style.visibility === "collapse"
      ) {
        return false;
      }

      current = current.parentElement;
    }

    const rect = element.getBoundingClientRect();

    const visibleWidth = Math.max(
      0,
      Math.min(rect.right, window.innerWidth) -
      Math.max(rect.left, 0)
    );

    const visibleHeight = Math.max(
      0,
      Math.min(rect.bottom, window.innerHeight) -
      Math.max(rect.top, 0)
    );

    return (
      visibleWidth > 50 &&
      visibleHeight > 50
    );
  }

  function isFilterVisible() {
    const modal = getFilterModal();
    const dialog = getFilterDialog();

    return Boolean(
      modal &&
      dialog &&
      isVisible(modal) &&
      isVisible(dialog)
    );
  }

  function isSearchVisible() {
    const modal = getSearchModal();

    if (!modal) return false;

    return isVisible(modal);
  }

  function isMenuActuallyOpen() {
    const details = getMenuDetails();

    return Boolean(
      details && details.open
    );
  }

  /* =====================================
     STARE GLOBALA SHOPIFY INBOX
  ===================================== */

  function updateChat() {
    const shouldHide = mobileQuery.matches &&
      (
        filtersOpen ||
        cartOpen ||
        menuOpen ||
        searchOpen
      );

    document.documentElement.classList.toggle(
      ACTIVE_CLASS,
      shouldHide
    );
  }

  /* =====================================
     FILTRE
  ===================================== */

  function openFilters() {
    closingFilters = false;
    filtersOpen = true;
    updateChat();
  }

  function closeFilters() {
    closingFilters = true;
    filtersOpen = false;
    updateChat();
  }

  /* =====================================
     COS LATERAL
  ===================================== */

  function openCart() {
    closingCart = false;
    cartOpen = true;
    updateChat();
  }

  function closeCart() {
    closingCart = true;
    cartOpen = false;
    updateChat();
  }

  /* =====================================
     MENIU MOBIL
  ===================================== */

  function openMenu() {
    menuOpen = true;
    updateChat();
  }

  function closeMenu() {
    menuOpen = false;
    updateChat();
  }

  /* =====================================
     CAUTARE MOBILA
  ===================================== */

  function openSearch() {
    closingSearch = false;
    searchOpen = true;
    searchOpenedAt = performance.now();
    updateChat();
  }

  function closeSearch() {
    closingSearch = true;
    searchOpen = false;
    updateChat();
  }

  /* =====================================
     SINCRONIZARE
  ===================================== */

  function synchronize() {
    scheduled = false;

    if (!mobileQuery.matches) {
      filtersOpen = false;
      cartOpen = false;
      menuOpen = false;
      searchOpen = false;

      closingFilters = false;
      closingCart = false;
      closingSearch = false;

      updateChat();
      return;
    }

    /* FILTRE - LOGICA STABILA V7 */

    if (closingFilters) {
      if (!isFilterVisible()) {
        closingFilters = false;
      }
    } else if (
      !filtersOpen &&
      isFilterVisible()
    ) {
      openFilters();
    }

    /*
      COS - LOGICA STABILA V7
      Nu resetam starea la animatii AJAX.
    */

    /* MENIU - LOGICA V8 */

    menuOpen = isMenuActuallyOpen();

    /* CAUTARE - LOGICA V9 */

    if (closingSearch) {
      if (!isSearchVisible()) {
        closingSearch = false;
      }
    } else if (searchOpen) {
      /*
        Nu consideram cautarea inchisa
        in timpul animatiei de deschidere.
      */

      if (
        performance.now() - searchOpenedAt > 1000 &&
        !isSearchVisible()
      ) {
        searchOpen = false;
      }
    } else if (isSearchVisible()) {
      openSearch();
    }

    updateChat();
  }

  function scheduleSync() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(synchronize);
  }

  function delayedSync() {
    scheduleSync();

    setTimeout(scheduleSync, 100);
    setTimeout(scheduleSync, 350);
    setTimeout(scheduleSync, 700);
    setTimeout(scheduleSync, 1200);
  }

  /* =====================================
     BUTON FILTRE
  ===================================== */

  function isFilterTrigger(element) {
    const trigger = element.closest(
      ".facets-toolbar button, " +
      ".facets-toolbar summary, " +
      ".mobile-facets__open, " +
      '[aria-controls*="FacetFilters"], ' +
      '[aria-controls*="facet"]'
    );

    if (
      trigger &&
      !trigger.closest(".popup-modal")
    ) {
      return true;
    }

    const button = element.closest(
      "button, summary, a"
    );

    if (
      !button ||
      button.closest(".popup-modal")
    ) {
      return false;
    }

    const text = (
      button.textContent || ""
    ).replace(/\s+/g, " ").trim();

    return /filtreaz[aă]\s*[șs]i\s*sorteaz[aă]/i.test(
      text
    );
  }

  /* =====================================
     BUTON COS
  ===================================== */

  function isCartTrigger(element) {
    return Boolean(
      element.closest(
        '#cart-icon-bubble--mobile,' +
        '#cart-icon-bubble,' +
        '[aria-controls="CartDrawer"]'
      )
    );
  }

  /* =====================================
     BUTON MENIU
  ===================================== */

  function isMenuTrigger(element) {
    return Boolean(
      element.closest(
        "menu-drawer > details > summary," +
        "menu-drawer .menu-drawer__button"
      )
    );
  }

  /* =====================================
     BUTON CAUTARE
  ===================================== */

  function isSearchTrigger(element) {
    return Boolean(
      element.closest(
        'modal-opener[data-modal="#header-modal-search"] ' +
        '.header__button,' +
        'modal-opener[data-modal="#header-modal-search"] ' +
        'a,' +
        'modal-opener[data-modal="#header-modal-search"] ' +
        'button'
      )
    );
  }

  /* =====================================
     INCHIDERE FILTRE
  ===================================== */

  function isFilterClose(element) {
    const modal = getFilterModal();

    if (
      !modal ||
      !modal.contains(element)
    ) {
      return false;
    }

    const button = element.closest("button");

    if (!button) return false;

    if (
      button.matches(
        ".popup-modal__toggle, " +
        ".popup-modal__close"
      )
    ) {
      return true;
    }

    const label = (
      button.getAttribute("aria-label") || ""
    ).toLowerCase().trim();

    return /^(inchide|închide|close)$/.test(
      label
    );
  }

  /* =====================================
     INCHIDERE COS
  ===================================== */

  function isCartClose(element) {
    const drawer = getCartDrawer();

    if (
      !drawer ||
      !drawer.contains(element)
    ) {
      return false;
    }

    const button = element.closest("button");

    if (!button) return false;

    if (
      button.matches(
        ".popup-modal__toggle, " +
        ".popup-modal__close, " +
        ".cart-drawer__close"
      )
    ) {
      return true;
    }

    const label = (
      button.getAttribute("aria-label") || ""
    ).toLowerCase().trim();

    return /^(inchide|închide|close)$/.test(
      label
    );
  }

  /* =====================================
     OVERLAY COS
  ===================================== */

  function isCartOverlay(element) {
    const drawer = getCartDrawer();

    if (!drawer) return false;

    const overlay = element.closest(
      ".popup-modal__overlay"
    );

    return Boolean(
      overlay &&
      (
        drawer.contains(overlay) ||
        drawer.parentElement ===
          overlay.parentElement
      )
    );
  }

  /* =====================================
     INCHIDERE CAUTARE
  ===================================== */

  function isSearchClose(element) {
    const modal = getSearchModal();

    if (!modal || !modal.contains(element)) {
      return false;
    }

    const button = element.closest(
      "button"
    );

    if (!button) return false;

    if (
      button.matches(
        ".popup-modal__toggle, " +
        ".popup-modal__close, " +
        ".modal__close-button, " +
        ".search-modal__close-button"
      )
    ) {
      return true;
    }

    const label = (
      button.getAttribute("aria-label") || ""
    ).toLowerCase().trim();

    return /^(inchide|închide|close|close search)$/.test(
      label
    );
  }

  /* =====================================
     OVERLAY CAUTARE
  ===================================== */

  function isSearchOverlay(element) {
    const modal = getSearchModal();

    if (!modal) return false;

    const overlay = element.closest(
      ".popup-modal__overlay"
    );

    return Boolean(
      overlay &&
      (
        modal.contains(overlay) ||
        modal.parentElement ===
          overlay.parentElement
      )
    );
  }

  /* =====================================
     EVENIMENTE CLICK
  ===================================== */

  document.addEventListener(
    "click",
    function (event) {
      if (!mobileQuery.matches) return;

      const target = event.target;

      if (!(target instanceof Element)) return;

      /* INCHIDERE FILTRE */

      if (isFilterClose(target)) {
        closeFilters();
        delayedSync();
        return;
      }

      /* INCHIDERE COS */

      if (
        isCartClose(target) ||
        isCartOverlay(target)
      ) {
        closeCart();
        delayedSync();
        return;
      }

      /* INCHIDERE CAUTARE */

      if (
        isSearchClose(target) ||
        isSearchOverlay(target)
      ) {
        closeSearch();
        delayedSync();
        return;
      }

      /* DESCHIDERE FILTRE */

      if (isFilterTrigger(target)) {
        openFilters();
        delayedSync();
        return;
      }

      /* DESCHIDERE COS */

      if (isCartTrigger(target)) {
        openCart();
        delayedSync();
        return;
      }

      /* MENIU MOBIL */

      if (isMenuTrigger(target)) {
        const details = getMenuDetails();

        if (details) {
          if (details.open) {
            closeMenu();
          } else {
            openMenu();
          }
        }

        delayedSync();
        return;
      }

      /* DESCHIDERE CAUTARE */

      if (isSearchTrigger(target)) {
        openSearch();
        delayedSync();
        return;
      }

      scheduleSync();
    },
    true
  );

  /* =====================================
     EVENIMENT NATIV MENIU
  ===================================== */

  document.addEventListener(
    "toggle",
    function (event) {
      const details = getMenuDetails();

      if (
        !details ||
        event.target !== details
      ) {
        return;
      }

      menuOpen = details.open;
      updateChat();
    },
    true
  );

  /* =====================================
     TASTA ESCAPE
  ===================================== */

  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key !== "Escape") return;

      if (filtersOpen) closeFilters();
      if (cartOpen) closeCart();
      if (menuOpen) closeMenu();
      if (searchOpen) closeSearch();

      delayedSync();
    },
    true
  );

  /* =====================================
     OBSERVARE AJAX
  ===================================== */

  function installObserver() {
    const observer = new MutationObserver(
      function (mutations) {
        const relevant = mutations.some(
          function (mutation) {
            if (mutation.type === "childList") {
              return true;
            }

            if (mutation.type === "attributes") {
              return [
                "class",
                "style",
                "hidden",
                "open",
                "aria-hidden"
              ].includes(
                mutation.attributeName
              );
            }

            return false;
          }
        );

        if (relevant) scheduleSync();
      }
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        "class",
        "style",
        "hidden",
        "open",
        "aria-hidden"
      ]
    });
  }

  /* =====================================
     SCHIMBARE DIMENSIUNE ECRAN
  ===================================== */

  function handleViewportChange() {
    if (!mobileQuery.matches) {
      filtersOpen = false;
      cartOpen = false;
      menuOpen = false;
      searchOpen = false;

      closingFilters = false;
      closingCart = false;
      closingSearch = false;

      updateChat();
    } else {
      delayedSync();
    }
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener(
      "change",
      handleViewportChange
    );
  } else {
    mobileQuery.addListener(
      handleViewportChange
    );
  }

  /* =====================================
     EVENIMENTE SUPLIMENTARE
  ===================================== */

  document.addEventListener(
    "transitionend",
    scheduleSync,
    true
  );

  document.addEventListener(
    "shopify:section:load",
    delayedSync
  );

  window.addEventListener(
    "pageshow",
    delayedSync
  );

  /* =====================================
     INITIALIZARE
  ===================================== */

  function initialize() {
    installStyles();
    installObserver();
    delayedSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

})();
